import { useEffect } from 'react';

/**
 * Performance optimization component that applies various 
 * performance enhancements to the application
 */
export const PerformanceOptimizer = () => {
  useEffect(() => {
    // Preload critical resources only on home page
    if (window.location.pathname === '/') {
      // DNS prefetch for external resources
      const dnsPrefetch = (domain: string) => {
        const link = document.createElement('link');
        link.rel = 'dns-prefetch';
        link.href = domain;
        document.head.appendChild(link);
      };

      // Prefetch external domains
      dnsPrefetch('https://api.leadconnectorhq.com');
      dnsPrefetch('https://fonts.googleapis.com');
      dnsPrefetch('https://fonts.gstatic.com');
    }

    // Optimize scroll performance
    let ticking = false;
    const optimizeScroll = () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          // Add any scroll optimizations here
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener('scroll', optimizeScroll, { passive: true });

    // Cleanup
    return () => {
      window.removeEventListener('scroll', optimizeScroll);
    };
  }, []);

  return null; // This component doesn't render anything
};